import Seo from "@/components/common/Seo";
import IndustriesSection from "@/components/home/IndustriesSection";
import FinalCTA from "@/components/home/FinalCTA";
import GlowOrbs from "@/components/common/GlowOrbs";
import SectionHeading from "@/components/common/SectionHeading";

export default function Industries() {
  return (
    <div data-testid="page-industries">
      <Seo title="Industries We Serve" description="Software, Data, AI, Cloud, Cybersecurity, DevOps, Business Analysis and QA Automation — US IT placement expertise." path="/industries" />
      <section className="relative pt-16 pb-8 overflow-hidden">
        <GlowOrbs />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHeading
            eyebrow="Industries We Serve"
            title="Eight US tech practices. One accountable partner."
            sub="Domain-specialist recruiters, not generalists — matching your skills to the right US employers."
          />
        </div>
      </section>
      <IndustriesSection />
      <FinalCTA />
    </div>
  );
}
